import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { AbstractControl, ControlContainer, FormArray, FormGroup, FormGroupDirective, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatRadioChange, MatRadioModule } from "@angular/material/radio";
import { TouchedErrorStateMatcher } from "../../../shared/other/touched-form-error-state-matcher";
import { TripRequestFormFactory } from "../../shared/trip-request-form.factory";

@Component({
  selector: 'app-trip-passenger',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatIconModule
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  templateUrl: './passenger-information.component.html',
  styleUrl: './passenger-information.component.scss',
})

export class PassengerInformationComponent implements OnInit {
    
    private postTripRequestFormDir = inject(FormGroupDirective);
    private tripRequestFormFactory = inject(TripRequestFormFactory);
    matcher = new TouchedErrorStateMatcher();
    tripRequestFg!: FormGroup;
    tripPassengerFr!: FormArray;
    appointmentDatesFr!: FormArray;
     

    ngOnInit(): void {
        this.tripRequestFg = this.postTripRequestFormDir.form.get("tripRequest") as FormGroup;
        this.appointmentDatesFr = this.tripRequestFg.get("tripAppointments") as FormArray;
        this.tripPassengerFr = this.tripRequestFg.get("tripPassengers") as FormArray;

    }

    onSamePassengerChange($event: MatRadioChange<boolean>) {
        this.tripRequestFg.get("samePassenger")?.setValue($event.value)
    }

    addPassenger(index: number) {
        const appointmentGp = this.appointmentDatesFr.at(index) as FormGroup;
        const passengerArray = appointmentGp.get('appointmentPassengers') as FormArray;
        passengerArray.push(this.tripRequestFormFactory.getPassengerFg());
    }

    addTripPassenger() {
        const passengerArray = this.tripRequestFg.get('tripPassengers') as FormArray;
        passengerArray.push(this.tripRequestFormFactory.getPassengerFg());
    }

    removeTripPassenger(passengerIndex: number) {
        const passengerArray = this.tripRequestFg.get('tripPassengers') as FormArray;
        if (passengerArray.length > 1) {
            passengerArray.removeAt(passengerIndex);
        }  
    }

    removePassenger(appointmentIndex: number, passengerIndex: number) {
        const appointmentGp = this.appointmentDatesFr.at(appointmentIndex) as FormGroup;
        const passengerArray = appointmentGp.get('appointmentPassengers') as FormArray;
        if (passengerArray.length > 1) {
            passengerArray.removeAt(passengerIndex);
        }
    }

    getPassenger(index: number): FormArray {
        const appointmentGp = this.appointmentDatesFr.at(index) as FormGroup;
        return appointmentGp.get('appointmentPassengers') as FormArray;
    }

    onMedicaidConsumerChange(event: MatRadioChange<boolean>): void {
        this.tripRequestFg.get("anotherMedicaidConsumer")?.setValue(event.value);
    }

    hasError(controlName: string, errorName: string): boolean {
        const control: AbstractControl | null = this.tripRequestFg.get(`${controlName}`);
        return !!control && control.hasError(errorName) && (control.dirty || control.touched);
    }
   
}